import React, { useEffect, useRef } from 'react';

const PaymentFormLocal = ({ htmlInfo }) => {
  const containerRef = useRef(null);
  const scriptsRef = useRef([]);

  useEffect(() => {
    if (!htmlInfo || !htmlInfo.html) {
      console.error("Données HTML manquantes pour le paiement");
      return;
    }

    const loadExternalScript = ({ js, jsIntegrity, jsAttributes }) => {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${js}"]`)) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = js;
        script.async = true;
        const { integrity, ...attributes } = jsAttributes || {};
        const sriHash = jsIntegrity || integrity;
        if (sriHash) {
          script.integrity = sriHash;
          script.crossOrigin = 'anonymous';
        }
        Object.entries(attributes).forEach(([name, value]) => {
          script.setAttribute(name, value);
        });
        script.onload = resolve;
        script.onerror = reject;

        document.head.appendChild(script);
        scriptsRef.current.push(script);
      });
    };

    const injectHTML = async () => {
      try {
        if (containerRef.current) {
          containerRef.current.innerHTML = htmlInfo.html;
        }

        if (htmlInfo.js) {
          // Lyra: thème obligatoire
          const kryptonMatch = htmlInfo.js.match(/^(.*\/krypton-client\/V4\.0\/)/);
          if (kryptonMatch) {
            const themeBase = `${kryptonMatch[1]}ext/`;
            if (!document.querySelector(`link[href="${themeBase}neon-reset.min.css"]`)) {
              const themeCss = document.createElement('link');
              themeCss.rel = 'stylesheet';
              themeCss.href = `${themeBase}neon-reset.min.css`;
              document.head.appendChild(themeCss);
            }
            await loadExternalScript(htmlInfo);
            await loadExternalScript({ js: `${themeBase}neon.js` });
          } else {
            await loadExternalScript(htmlInfo);
          }
        }

        if (containerRef.current) {

          const scripts = containerRef.current.querySelectorAll('script');
          scripts.forEach(script => {
            try {
              const newScript = document.createElement('script');
              if (script.src) {
                newScript.src = script.src;
              } else {
                newScript.textContent = script.textContent;
              }

              script.parentNode.replaceChild(newScript, script);
              scriptsRef.current.push(newScript);
            } catch (error) {
              console.error('Erreur lors de l\'exécution du script:', error);
            }
          });
        }



      } catch (error) {
        console.error("Erreur lors de l'injection:", error);
      }
    };

    injectHTML();

    return () => {
      scriptsRef.current.forEach(script => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
      scriptsRef.current = [];

      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }

    };
  }, [htmlInfo]);

  return (
    <div
      ref={containerRef}
      className="payment-container"
      style={{ minHeight: '656px',minWidth:"400px" }}
    />
  );
};
export default PaymentFormLocal;
